import { Component, input } from '@angular/core';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
/**
 * Fundamental Button Element
 *
 * @deprecated [#1] Deprecating in favor of using native button element
 * [#2] Will be removed from project once confirmed all projects no longer use Fun Button
 * [#3] RIP FunButton
 *
 * @param text
 */
export class ButtonComponent {
    /**
     * Text to display
     */
    readonly text = input<string>(undefined);

    /**
     * Specific class
     */
    readonly styleClass = input<string>('');

    /**
     * Name of the icon
     */
    readonly hasIcon = input<string>(undefined);

    /**
     * Loading state for requests made from Button
     */
    readonly isLoading = input<boolean>(undefined);

    /**
     * Button type: can be submit (default), reset, button
     */
    readonly buttonType = input<string>(undefined);

    /**
     * Set default value for disabled attribute
     */
    readonly disabled = input<boolean>(undefined);
}

/**
 * Used in Settings Security
 * Used in Settings Legrand
 */
